import { cn } from '../../lib/utils';
import React from "react";
import { NavLink } from "react-router-dom";
import { useLayout } from "../../context/LayoutContext";
import { useTheme } from "../../context/ThemeContext";
import { Settings } from "lucide-react";

const Sidebar = () => {
  const { isSidebarCollapsed, expandedWidth, collapsedWidth, isMobile, isMobileMenuOpen, closeMobileMenu } = useLayout();
  const { isDark } = useTheme();
  const sidebarWidth = isSidebarCollapsed ? collapsedWidth : expandedWidth;

  const itemBaseClasses = "flex items-center px-[16px] py-[10px] cursor-pointer transition-colors duration-200 hover:bg-white/10 rounded-[6px]";

  return (
    <>
      {/* Backdrop for mobile */}
      {isMobile && isMobileMenuOpen && (
        <div
          className={cn("fixed inset-0 bg-black/50 z-30")}
          onClick={closeMobileMenu}
        />
      )}
      {/* Sidebar */}
      <div
        className={cn(
          "fixed left-0 top-0 h-screen overflow-y-auto flex flex-col transition-all duration-300 ease-in-out",
          isMobile ? 'z-40' : 'z-20',
          isMobile && !isMobileMenuOpen ? '-translate-x-full' : 'translate-x-0'
        )}
        style={{
          width: isMobile ? `${expandedWidth}px` : `${sidebarWidth}px`,
          backgroundColor: isDark ? '#161515' : '#072837',
          borderRight: isDark ? '1px solid #292929' : 'none'
        }}
      >
      {/* Logo */}
      <div className={cn("pt-[21px] pl-[16px] pr-[16px] flex items-center")}>
        <img
          src={isMobile || !isSidebarCollapsed ? "/assets/icons/logowhite.svg" : "/assets/icons/logocollapsed.svg"}
          alt="Jamesons Logo"
          className={isMobile || !isSidebarCollapsed ? "w-[114px] h-[21px]" : "w-[28px] h-[28px]"}
        />
      </div>

      {/* Navigation Menu */}
      <nav className={cn("mt-[46px] flex flex-col gap-[4px]")}>
        {/* Dashboard */}
        <NavLink to="/dashboard" title="Dashboard" onClick={() => isMobile && closeMobileMenu()}>
          {({ isActive }) => (
            <div
              className={cn(
                itemBaseClasses,
                isSidebarCollapsed && !isMobile ? "justify-center" : "gap-[12px]",
                isActive ? "text-[#cd6d2c]" : "text-white"
              )}
            >
              <img
                src="/assets/icons/dashboard.svg"
                alt=""
                className={cn("w-[20px] h-[20px]")}
                style={{
                  filter: isActive
                    ? "brightness(0) saturate(100%) invert(48%) sepia(69%) saturate(1077%) hue-rotate(354deg) brightness(92%) contrast(85%)"
                    : "brightness(0) invert(1)"
                }}
              />
              {(isMobile || !isSidebarCollapsed) && (
                <span className={cn("text-[16px] font-medium leading-normal whitespace-nowrap")}>
                  Dashboard
                </span>
              )}
            </div>
          )}
        </NavLink>

        {/* Submissions */}
        <NavLink to="/submission" title="Submissions" onClick={() => isMobile && closeMobileMenu()}>
          {({ isActive }) => (
            <div
              className={cn(
                itemBaseClasses,
                isSidebarCollapsed && !isMobile ? "justify-center" : "gap-[12px]",
                isActive ? "text-[#cd6d2c]" : "text-white"
              )}
            >
              <img
                src="/assets/icons/submissions.svg"
                alt=""
                className={cn("w-[20px] h-[20px]")}
                style={{
                  filter: isActive
                    ? "brightness(0) saturate(100%) invert(48%) sepia(69%) saturate(1077%) hue-rotate(354deg) brightness(92%) contrast(85%)"
                    : "brightness(0) invert(1)"
                }}
              />
              {(isMobile || !isSidebarCollapsed) && (
                <span className={cn("text-[16px] font-medium leading-normal whitespace-nowrap")}>
                  Submissions
                </span>
              )}
            </div>
          )}
        </NavLink>

        {/* New Mailroom Form */}
        <NavLink to="/Submissionprogress" title="New Mailroom Form" onClick={() => isMobile && closeMobileMenu()}>
          {({ isActive }) => (
            <div
              className={cn(
                itemBaseClasses,
                isSidebarCollapsed && !isMobile ? "justify-center" : "gap-[12px]",
                isActive ? "text-[#cd6d2c]" : "text-white"
              )}
            >
              <img
                src="/assets/icons/claimform.svg"
                alt=""
                className={cn("w-[20px] h-[20px]")}
                style={{
                  filter: isActive
                    ? "brightness(0) saturate(100%) invert(48%) sepia(69%) saturate(1077%) hue-rotate(354deg) brightness(92%) contrast(85%)"
                    : "brightness(0) invert(1)"
                }}
              />
              {(isMobile || !isSidebarCollapsed) && (
                <span className={cn("text-[16px] font-medium leading-normal whitespace-nowrap")}>
                  New Submission
                </span>
              )}
            </div>
          )}
        </NavLink>

        {/* Levy Automations */}
        <NavLink to="/levy-automations" title="Levy Automations" onClick={() => isMobile && closeMobileMenu()}>
          {({ isActive }) => (
            <div
              className={cn(
                itemBaseClasses,
                isSidebarCollapsed && !isMobile ? "justify-center" : "gap-[12px]",
                isActive ? "text-[#cd6d2c]" : "text-white"
              )}
            >
              <Settings
                size={20}
                className={cn("w-[20px] h-[20px]")}
                style={{
                  color: isActive ? "#cd6d2c" : "#ffffff"
                }}
              />
              {(isMobile || !isSidebarCollapsed) && (
                <span className={cn("text-[16px] font-medium leading-normal whitespace-nowrap")}>
                  Levy Automations
                </span>
              )}
            </div>
          )}
        </NavLink>
      </nav>
    </div>
    </>
  );
};

export default Sidebar;
